import Translate from './Translate';
import { BAD_WORDS } from '../components/catalogs';

const imageRegex = /\.(gif|jpe?g|tiff?|png|webp|bmp)$/i;
const validUrlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

const PREVIEW_TYPES = {
  gif: 'image',
  jpeg: 'image',
  jpg: 'image',
  png: 'image',
  bmp: 'image',
  webp: 'image',
  pdf: 'pdf',
  mpeg: 'audio',
  mp3: 'audio',
  ogg: 'audio',
  wav: 'audio',
  default: 'default',
};

export const getMimeType = (url) => {
  const extension = url.match(imageRegex);
  const extensionType = extension ? extension[1] : 'default';
  return PREVIEW_TYPES[extensionType];
};

export const isValidUrl = url => validUrlRegex.test(url);

export const isImageWithText = (message) => {
  const urlMatch = message.match(/\[(https?:\/\/[^\]]+)\]/);
  const url = urlMatch ? urlMatch[1] : null;
  // Remove the URL from the message
  const cleanedMessage = message.replace(/\[https?:\/\/[^\]]+\]/, '');
  return {content: cleanedMessage || message, url: url}
};

export const scrollDown = ({ contentRef, scrollRef }) => {
  if (!scrollRef.current && !contentRef.current) return;
  const offsetTop = scrollRef.current ? scrollRef.current.offsetTop : 0;
  contentRef.current.scrollTo({
    top: offsetTop,
    behavior: 'smooth',
  });
};

export default class Utils {
  /**
   * @param {*} view Recibe el tipo de vista
   * activa y retorna un link
   */
  static getLinkEmailAuth(isLogin) {
    if (isLogin) {
      return '/login/email';
    }
    return '/register';
  }

  /**
   * Retorna el nivel del seenapse
   * @param {int} numberOfSeenapses
   */
  static getSeenapserLevel(numberOfSeenapses) {
    let rank;

    if (numberOfSeenapses === 0) {
      rank = Translate.get('newbie', 'Newbie');
    }

    if (numberOfSeenapses > 0 && numberOfSeenapses < 21) {
      rank = Translate.get('adept', 'Adept');
    }

    if (numberOfSeenapses > 20 && numberOfSeenapses < 100) {
      rank = Translate.get('skiled', 'Skilled');
    }

    if (numberOfSeenapses > 99 && numberOfSeenapses < 1000) {
      rank = Translate.get('expert', 'Expert');
    }

    if (numberOfSeenapses > 999) {
      rank = Translate.get('master', 'Master');
    }
    return rank;
  }
}

export const isInSummaryModal = (pathName) => {
  const lengthPathName = pathName.split('/');
  return lengthPathName.length > 5;
};

export const escapeSpecialCharacters = text => ({ __html: text });

export const defaultAvatar = (event, avatar) => {
  event.target.onerror = null;
  event.target.src = `${avatar}`;
};

export const UrlShortener = (location) => {
  const path = location.pathname.split('/');
  const pathCurrently = path.slice(0, path.length - 2);
  return pathCurrently.join('/');
};

export const isAllowedLength = (text) => {
  if (text) {
    const maxCharacters = 12;
    return !(text.__html.length > maxCharacters);
  }
};

export const getMaxHeight = (element) => {
  const valueTotalLineHeight = 2.6;
  const fontSize = window
    .getComputedStyle(element)
    .getPropertyValue('font-size')
    .replace('px', '');
  element.style.maxHeight = `${fontSize * valueTotalLineHeight}px`;
  return Math.round(fontSize * valueTotalLineHeight);
};

export const ellipsisText = (title) => {
  title.forEach((item) => {
    const maxHeight = getMaxHeight(item);
    while (item.offsetHeight > maxHeight) {
      item.innerText = item.innerText.replace(/\W*\s(\S)*$/, '...');
    }
  });
};

export const getHeigthText = () => {
  const p = document.createElement('p');
  p.style.fontSize = 'calc(7px + 4 * ((100vw - 320px) / (1600 - 320)))';
  document.body.appendChild(p);
  return getMaxHeight(p);
};

export const isImageUrl = (url) => {
  const imageExtensions = ['png', 'gif', 'svg', 'jpg', 'jpeg'];
  const dotSlots = url.split('.');
  const extension = dotSlots[dotSlots.length - 1];
  return imageExtensions.includes(extension);
};

export const signOut = (browserHistory) => {
  localStorage.clear();
  browserHistory.push('/');
};

export const decode = (token) => {
  const data = token.split('.')[0];

  const decoded = decodeURIComponent(
    Array.prototype.map
      .call(
        window.atob(data.replace(/_/g, '/').replace(/-/g, '+')),
        c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`,
      )
      .join(''),
  );

  return JSON.parse(decoded);
};

export const getTypeResult = (selected) => {
  switch (selected) {
    case 'followees':
      return 'people';
    case 'followers':
      return 'people';
    case 'favs':
      return 'seenapse'; // s
    case 'seenapses':
      return 'seenapses';
    case 'seenapsed':
      return 'seenapsed';
    case 'favorited':
      return 'favorited';
    case 'followed':
      return 'people';
    default:
      return 'seenapses';
  }
};

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const wordFilter = (value) => {
  const newValues = value.replace(/,/g, ' ').split(' ');

  const filteredValue = newValues.reduce((acc, current) => ({
    ...acc,
    [current.toLowerCase()]: current.toLowerCase(),
  }), {});

  return BAD_WORDS.map(item => filteredValue[item]).filter(item => item);
};



// WEBPACK FOOTER //
// ./src/utils/Utils.js